import { render, staticRenderFns } from "./LayoutEditor.vue?vue&type=template&id=6c6442e3&scoped=true&"
import script from "./LayoutEditor.vue?vue&type=script&lang=js&"
export * from "./LayoutEditor.vue?vue&type=script&lang=js&"
import style0 from "./LayoutEditor.vue?vue&type=style&index=0&id=6c6442e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6442e3",
  null
  
)

export default component.exports